import styled, { keyframes } from "styled-components";

export const Loader = styled.div`
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  transition: all 0.3s;
  opacity: 1;
  pointer-events: visible;
`;
export const LoaderNew = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  transition: all 0.3s;
  opacity: 1;
  pointer-events: visible;
  position: absolute;
  top: 50%;
  left: 50%;
`;
export const LoaderContentNew = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 999;
  transform: translate(-50%, -50%);
`;
export const LoaderContent = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled.div`
  width: 15px;
  height: 15px;
  border: 2px solid #fff;
  border-top: 2px solid #2a3da3;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;
